import gql from 'graphql-tag';

import albumFolderDetails from './albumFolderDetails';
import albumFolderCustomTags from './albumFolderCustomTags';
import { WebGalleryAlbumCustomPrintFields } from '../../../../../../web-gallery/graphql/fragments/album';
import { VendorDetails } from '../../../../../../../graphql/fragments/account';

const albumMembershipGroupSimplifiedDetails = gql`
  fragment albumMembershipGroupSimplifiedDetails on AlbumMembershipGroup {
    id
    is_album
    album {
      id
      name
      album_type
      album_subtype
      creator {
        ...VendorDetails
      }
      photos_raw: photos {
        total
      }
      photos(use_all_photos_mode: true) {
        total
      }
      green_screen_enabled
      social_share_enabled
      hash_code
      display_public_photo_attribution
      search_subscription_credits_joins_enabled
      pre_paid: is_demo
      root_album_folder {
        ...albumFolderDetails
        ...albumFolderCustomTags
        picture_day_enabled
        matching_disabled
        download_without_watermark
        price {
          value
        }
        pricing_categories {
          total
          records {
            id
            pricing_category {
              id
              name
            }
          }
        }
      }
      account_favorite_photos(slice: { limit: 9999 }) {
        total
        records {
          id
          photo {
            id
          }
        }
      }
      pricing_categories {
        total
        records {
          id
          pricing_category {
            id
            name
          }
        }
      }
      picture_day_enabled
      is_video_album
      slideshow {
        status
      }
      ...WebGalleryAlbumCustomPrintFields
    }
    album_folder {
      ...albumFolderDetails
      ...albumFolderCustomTags
      picture_day_enabled
      matching_disabled
      has_album_photos
      download_without_watermark
      account_favorite_photos(slice: { limit: 9999 }) {
        total
        records {
          id
          photo {
            id
          }
        }
      }
      price {
        value
      }
      pricing_categories {
        total
        records {
          id
          pricing_category {
            id
            name
          }
        }
      }
    }
  }
  ${albumFolderDetails}
  ${albumFolderCustomTags}
  ${WebGalleryAlbumCustomPrintFields}
  ${VendorDetails}
`;

export default albumMembershipGroupSimplifiedDetails;
